import {
  makeRequired, passwordValidator,
} from '../../../../../OUI/Inputs';

export const newPasswordFieldValidator = makeRequired(passwordValidator);
